import GrantsGrid from './components/GrantsGrid';

export default GrantsGrid;
